export default __webpack_public_path__ + "52396d6c6871280fa0195f068cf1a006.png";